/* import __COLOCATED_TEMPLATE__ from './oauth-providers.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';
import { dropTask } from 'ember-concurrency';
import { showModal } from 'sh-www/utils/modal-controls';

const CLASS_NAME = 'SH-c-oauth-providers';

class OauthProvidersComponent extends Component {

  get className() {
    return CLASS_NAME;
  }

  get classNames() {
    return clsx(
      CLASS_NAME,
      this.args.class,
    );
  }

  get oauthProvidersLoading() {
    return this.args.oauthProviders == null;
  }

  get googleOAuthProvider() {
    return this.args.oauthProviders?.find(oauthProvider => oauthProvider.provider === 'google');
  }

  @dropTask
  *googleSSOCallback({ credential }) {
    yield this.args.onGoogleSSO(credential);
  }

  @dropTask
  *removeGoogleSSO() {
    showModal(this, 'confirmation', {
      titleText: 'Unlink Google SSO',
      bodyText: 'Are you sure you want to un-link your Google account?',
      actionButtonText: 'Confirm',
      confirmAction: () => {
        this.args.onRemoveOAuthProvider(this.googleOAuthProvider);
      },
      cancelButtonText: 'Cancel',
    });
  }
}

export default OauthProvidersComponent;
